<template>
  <div v-if="hasAudioPermissionIssue" class="banner error relative flex gap-1">
    <svg
      class="text-gray-500 w-6 h-6 -mt-1/2 absolute top-1 left-1"
      fill="none"
      viewBox="0 0 24 24"
    >
      <path
        fill="currentColor"
        d="M4.47 21h15.06c1.54 0 2.5-1.67 1.73-3L13.73 4.99c-.77-1.33-2.69-1.33-3.46 0L2.74 18c-.77 1.33.19 3 1.73 3zM12 14c-.55 0-1-.45-1-1v-2c0-.55.45-1 1-1s1 .45 1 1v2c0 .55-.45 1-1 1zm1 4h-2v-2h2v2z"
      />
    </svg>

    <div class="px-10">
      {{ $t('NO_MICROPHONE_ACCESS') }}
    </div>
    <button
      class="w-10 h-10 rounded-lg flex items-center justify-center absolute top-0 right-0"
      aria-label="Close"
      @click="closeBanner"
    >
      <fluent-icon icon="dismiss" size="18" />
    </button>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import FluentIcon from 'shared/components/FluentIcon/Index.vue';

export default {
  components: {
    FluentIcon,
  },
  computed: {
    ...mapGetters({
      hasAudioPermissionIssue: 'conversation/getHasAudioPermissionIssue',
    }),
  },
  methods: {
    closeBanner() {
      this.$store.dispatch('conversation/setConversationUIFlag', {
        hasAudioPermissionIssue: false,
      });
    },
  },
};
</script>

<style scoped lang="scss">
@import '~widget/assets/scss/variables.scss';
.banner {
  color: $color-white;
  font-size: 12px;
  font-weight: $font-weight-bold;
  padding: $space-slab;
  background: $color-error;
  text-align: left;
  line-height: 1.2;
  z-index: 999;
}
</style>
